// NEED PlaybackActions, playback actions, sample player actions, API action constants, saga imports, logger, application actions, audio player utils
import { call, delay, fork, put, race, select, take } from 'redux-saga/effects';

import * as CrosstabActions from '../actions';
import * as CrosstabConstants from '../constants';
import * as D from '../deps';
import * as CrosstabUtils from '../utils';

const log = D.Logger.child({ component: 'sagas/workers/CrossTab' });

export function* initialize() {
  yield put(CrosstabActions.setMyTabId());
  yield put(CrosstabActions.setCurrentlyPlayingTabId(CrosstabUtils.getCurrentlyPlayingTabId()));
}

// if another window is playing, notify it to pause and wait for it to pause first before continuing
export function* handleCrossTabPlay() {
  const hasCurrentlyPlayingTab = yield select(CrosstabUtils.isCurrentlyPlayingTab);
  if (!hasCurrentlyPlayingTab) {
    yield fork(CrosstabUtils.sendAction, {
      type: D.Constants.Playback.ActionTypes.XTAB_PLAY,
    });

    const { delayed } = yield race({
      paused: take(D.Constants.Playback.ActionTypes.XTAB_PAUSED),
      delayed: delay(CrosstabConstants.GIVE_UP_XTAB_PAUSE_AFTER),
    });
    if (delayed) {
      log.info(
        'Attempted to pause music on other active tab without success after 2 seconds. Giving up and playing music anyway.',
      );
    }
  }
  const myTabId = yield select(CrosstabUtils.getMyTabId);

  // set the current tab in localstorage
  yield fork(CrosstabUtils.setCurrentlyPlayingTabId, myTabId);

  // set the current tab in the store
  yield put(CrosstabActions.setCurrentlyPlayingTabId(myTabId));

  // set the current tab in other tabs
  yield fork(CrosstabUtils.sendAction, CrosstabActions.setCurrentlyPlayingTabId(myTabId));
}

// when another tab starts playback, if this tab is the active tab
// and playing music, pause it and notify other tabs of the paused state.
export function* handleCrossTabPlayAction() {
  const hasCurrentlyPlayingTab = yield select(CrosstabUtils.isCurrentlyPlayingTab);

  if (hasCurrentlyPlayingTab) {
    const isAudioPlaying = yield select(D.getInDomain('playback.utils.isAudioPlayerPlaying'));
    const isSamplePlaying = yield select(D.getInDomain('playback.utils.isAuxPlaybackPlaying'));

    if (isAudioPlaying) {
      // in the case of music playing, go ahead and pause and wait
      // until the successful call to the station/playbackPaused api end point
      yield call(D.putAndWait, D.Actions.UseCases.pauseTrack());
      yield take(D.Constants.Api.ApiActions.PLAYBACK_PAUSED_SUCCESS);
    } else if (isSamplePlaying) {
      yield put(D.Actions.SamplePlayer.endSample());
    }

    // notify other tabs of the the paused state of this tab
    yield fork(CrosstabUtils.sendAction, {
      type: D.Constants.Playback.ActionTypes.XTAB_PAUSED,
    });
  }
}
